import { Link } from 'react-router-dom'

const HeaderLogin = ({user}) => {

    return (
        <header className="flex items-center justify-end w-full bg-white p-3">
            <span className="text-base text-custlog-primary mx-2 font-medium">Iniciar Sesión</span>
            <Link to={user?.projectId ? `/${user?.projectId}` : '/'} className="p-2 bg-custlog-primary rounded-full cursor-pointer hover:bg-opacity-80 transition duration-300 ease-in-out">
                <svg width="21" height="21" fill="#fff" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 7 9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5Zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14Z"></path>
                </svg>
            </Link>
        </header>
    )
}

export default HeaderLogin